import yup from '../libs/yup'

export type GroupRegisterForm = {
  _id?: string
  name: string
  role?: string
  users?: any
}

export const registerSchema = yup.object().shape({
  name: yup.string().required().label('Nome'),
  role: yup.string().required().label('Permissão'),
})
